import React from 'react';
import PropTypes from 'prop-types';
import helpers from '../../utils/helpers';

const DropdownHeader = ({ headerName }) => (
  <h3 className="text-bold text-xxxs pl-xs mt-xxxs">
    {helpers.decodeEntities(headerName || '')}
  </h3>
);
DropdownHeader.propTypes = {
  headerName: PropTypes.string.isRequired,
};

export default DropdownHeader;
